import React from "react";

import {
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextControl,
  Form,
  Divider,
} from "@tiny/components";
import { useAddSegmentDialog } from "./AddSegmentDialog.hooks";

export interface AddSegmentDialogProps {
  open: boolean;
  onClose: () => void;
  mode?: "create" | "export";
  title?: string;
  subtitle?: string;
  segmentIds?: string[];
}

function AddSegmentDialog(props: AddSegmentDialogProps) {
  const { open, onClose } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
      disableBackdropClose
    >
      <AddSegmentDialogContent {...props} />
    </Dialog>
  );
}

function AddSegmentDialogContent(props: AddSegmentDialogProps) {
  const {
    onClose,
    title = "Add new segment",
    subtitle = "Segments update cohorts of Customers based on your criteria automatically.",
    mode = "create",
  } = props;

  const { form, handleSubmit, continueAdding, executing } =
    useAddSegmentDialog(props);

  return (
    <>
      <DialogTitle subtitle={subtitle} onClose={onClose}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Form form={form} onSubmit={handleSubmit}>
          <TextControl
            name="name"
            label="Name"
            defaultValue=""
            required
            maxLength={140}
            placeholder="Give your segment an easy to identify name"
          />
        </Form>
        <Divider mt={4} />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          disabled={executing}
          onClick={continueAdding}
          loading={executing}
        >
          {mode === "create" ? "Continue" : "Export"}
        </Button>
      </DialogActions>
    </>
  );
}

export default AddSegmentDialog;
